export default "__VITE_ASSET__WJVKy56S__"